<template>
    <div>
        <h3>
            {{ humanDate }}
            <v-chip v-if="day.note" small text-color="red" class="ml-1">
                {{ day.note }}
            </v-chip>
        </h3>
        <v-container  v-if="day.persons.length > 0" class="pa-0 ma-0">
            <v-row no-gutters v-for="person in day.persons" :key="person.id">
                <v-col
                    cols="10"
                    md="3"
                >
                    {{ person.name}}
                </v-col>
                <!-- <v-col cols="2" sm="1">
                        <v-chip small>
                    <v-icon left color="red">mdi-phone</v-icon>
                    +46 70 69 55 766
                    </v-chip>
                    <a href="tel:+46706955766"></a>
                </v-col> -->
                <v-col
                    cols="12"
                    sm="8">
                    <DaySchedule :color="person.role.color" :periods="person.periods" :width="width" />
                </v-col>
            </v-row>
        </v-container>
        <div v-if="day.persons.length === 0">
            <em>Inga personer schemalagda…</em>
        </div>
    </div>
</template>

<script>
import DaySchedule from './DaySchedule';

export default {
    props: {
        "date": Date,
        "day": Object,
        "width": Number,
    },
    methods: {
        h: (n) => {
            const d = n % 4;
            if (d == 1) {
                return 10
            } else if (d == 0 || d == 2) {
                return 5
            } else if (d == 3) {
                return 7
            }
            return 0
        },
        wholeHour: (n) => {
            return n % 4 == 0
        },
        xForTime: (time) => {
            let x = 5
            x += time.hour * 4 * 5
            x += time.minute * 5
            return x
        },
        timeString: (time) => {
            const hour = time.hour
            const minute = time.minute.toString().padStart(2, '0')
            return `${hour}:${minute}`
        },
    },
    computed: {
        humanDate: function() {
            const options = { weekday: "long", month: "long", day: "numeric" }
            return this.date.toLocaleDateString("sv-SE", options)
        }
    },
    components: {
        DaySchedule,
    }
};
</script>